import lax from "lax.js";

lax.addPreset("mobileBasic", () => {
  return {
    "data-lax-translate-y_mobile": "250 150 ,0 0",
  };
});

lax.addPreset("mobileSlow1", () => {
  return {
    "data-lax-translate-y_mobile": "250 125 ,150 0",
  };
});

lax.addPreset("mobileSlow2", () => {
  return {
    "data-lax-translate-y_mobile": "350 50 ,200 0",
  };
});

lax.addPreset("mobileSlow3", () => {
  return {
    "data-lax-translate-y_mobile": "250 250 ,125 0",
  };
});

lax.addPreset("mobileSlow4", () => {
  return {
    "data-lax-translate-y_mobile": "300 50 ,250 0",
  };
});

lax.addPreset("fadeMobile", () => {
  return {
    "data-lax-opacity_mobile": "0 0.7, 400 -0.5",
  };
});

lax.addPreset("fadeMobileQuick", () => {
  return {
    "data-lax-opacity_mobile": "150 0.7, 400 -0.5",
  };
});

lax.addPreset("fadeMobileText", () => {
  return {
    "data-lax-opacity_mobile": "150 1, 400 -1.5",
  };
});
